import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { objectToArray } from "utils";
import { toggleScheduleDays } from "store/actions";

function Custom(props) {
  const weekDays = props.enums.WeekDays.props;
  const isFirstRender = React.useRef(true);

  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (
      props.weekDays.length === 5 &&
      [1, 2, 3, 4, 5].every(day => props.weekDays.includes(day))
    ) {
      props.checkDaily(true);
    }
  }, [props.weekDays]);

  return (
    <React.Fragment>
      <div class="idapp__schedule idapp-weekly__schedule id-hide">
        <label class="idapp-form__label">Backup start days:</label>
      </div>
      <div className="sche_backup_item custom random_schedule">
        <div className="days_wrap">
          {objectToArray(weekDays, { 1: "priority" }).map(val => (
            <div
              key={val.code}
              className={[
                "days_block",
                val.name + "__day",
                props.weekDays.includes(val.code) ? "active" : null
              ].join(" ")}
              onClick={() => {
                props.toggleScheduleDays(val.code);
              }}
            >
              {val.name}
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    weekDays: state.backupSettings.scheduleInfo.weekDays,
    enums: state.common.enums
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleScheduleDays
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Custom);
